import { queryClient } from "@/lib/query";
import { request } from "@/lib/request";
import { TodoVault } from "@/lib/types";
import { useMutation } from "@tanstack/react-query";

export const useDeleteTodoVault = () => {
  return useMutation({
    mutationFn: async (data: { vaultId: string }) => {
      const res = await request.delete<{ data: TodoVault | void }>(
        `/internal/todos/vaults/${data.vaultId}`,
      );
      queryClient.invalidateQueries({
        queryKey: ["todos", "vaults"],
      });
      return res.data.data;
    },
  });
};
